module.exports = __webpack_public_path__ + "images/blog/blog_card/no_image_cd07827135022d513c243f63719c11e5.png";